<template>
    <el-dialog
        title="批量编辑假期余额"
        :visible.sync="holidayBalanceBatchDialogVisible"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        class="custom-form-dialog custom-tip-form-dialog custom-holiday_balance_dialog"
    >
        <div v-loading="holidayBalanceBatchLoading">
            <p class="dialog-txt-tip">适用于批量新增/编辑假期余额，编辑后同步假期余额天数</p>
            <el-form
                :model="holidayBalanceForm"
                :rules="holidayBalanceFormRules"
                label-position="top"
                ref="holidayBalanceForm"
                size="small"
            >
                <el-form-item label="假期余额天数" prop="new_balance">
                    <el-input placeholder="请输入" v-model="holidayBalanceForm.new_balance"> </el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button size="small" type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled"
                >确定</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { UpdateHolidayBalance } from "@/api";
export default {
    name: "AttendanceHolidayBalanceBatch",
    props: {
        holidayBalanceBatchDialogVisible: {
            type: Boolean,
            default: false,
        },
        all_uids: {
            type: Array,
            default: () => [],
        },
        holiday_id: "", // 假期config_id
    },
    data() {
        return {
            holidayBalanceBatchLoading: false,
            holidayBalanceForm: {
                new_balance: "",
            },
            holidayBalanceFormRules: {
                new_balance: [{ required: true, message: "请输入假期余额天数", trigger: "blur" }],
            },
            btnDisabled: false,
        };
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:holidayBalanceBatchDialogVisible", false);
        },
        handleDialogConfirm() {
            this.$refs.holidayBalanceForm.validate((valid) => {
                if (valid) {
                    this.holidayBalanceBatchLoading = true;
                    this.btnDisabled = true;
                    const params = {
                        all_uids: this.all_uids,
                        type: "batch",
                        holiday_id: this.holiday_id,
                        new_balance: this.holidayBalanceForm.new_balance
                            ? Number(this.holidayBalanceForm.new_balance)
                            : "",
                    };
                    UpdateHolidayBalance(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.btnDisabled = false;
                                this.holidayBalanceBatchLoading = false;
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.handleDialogClose();
                                        this.$emit("callbackSuccess");
                                    },
                                });
                            } else {
                                this.btnDisabled = false;
                                this.holidayBalanceBatchLoading = false;
                                // this.$message.error(res.message);
                            }
                        })
                        .catch(() => {
                            this.holidayBalanceBatchLoading = false;
                            this.btnDisabled = false;
                        });
                }
            });
        },
    },
};
</script>

<style lang="scss">
.custom-holiday_balance_dialog {
    .el-dialog__body {
        padding-bottom: 116px;
    }
}
</style>
